<template>
  <div class="border">
    <template>
      <el-table ref="versionManageTable" :data="tableData" border stripe highlight-current-row @selection-change="handleSelectionChange">
        <el-table-column prop="status" label="状态" header-align="center" align="center">
          <template slot-scope="scope">
            <span v-if="!scope.row.status">草稿</span>
            <span v-else>正式</span>
          </template>
        </el-table-column>>
        <el-table-column prop="version" label="版本号" header-align="center" align="center" />
        <el-table-column prop="description" label="版本描述" header-align="center" align="center"/>
        <el-table-column prop="updateUser" label="最后修改人" header-align="center" align="center"/>
        <el-table-column prop="updatedAt" label="更新时间" header-align="center" align="center"/>
        <el-table-column label="操作" header-align="center" align="left" min-width="170">
          <template slot-scope="scope">
            <el-button @click="copyToEnv(scope.row, 'fat')" type="primary" plain size="mini">拷贝到测试</el-button>
            <el-button @click="copyToEnv(scope.row, 'uat')" type="primary" plain size="mini" v-if="!scope.row.status">预发试运行</el-button>
            <el-button @click="doRelease(scope.row)" type="primary" plain size="mini" v-if="!scope.row.status">发布</el-button>
            <el-button @click="deleteDraft(scope.row)" type="primary" plain size="mini" v-if="!scope.row.status">删除草稿</el-button>
          </template>
        </el-table-column>
        <el-table-column label="详情" header-align="center" align="center" min-width="110">
          <template slot-scope="scope">
            <el-button @click="showHistory(scope.row)" type="primary" plain size="mini">查看修改历史</el-button>
            <el-button @click="showStrategyDetail(scope.row)" type="primary" plain size="mini">查看策略详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page="pageIndex"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="->,total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </template>
    <!--子组件-->
    <history :ifshow="showHistoryFlag" :strategyHistory="strategyHistory" @handleCloseDialog="showHistoryFlag=false;strategyHistory=null;"></history>
  </div>
</template>

<script>
import debounce from 'throttle-debounce/debounce'

export default {
  props: {
    strategy: Object
  },
  data () {
    return {
      searchForm: {
        code: null
      },
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      selectIds: [],
      strategyHistory: null,
      showHistoryFlag: false
    }
  },
  created () {
    this.searchForm.code = this.strategy.code
    this.list()
  },
  methods: {
    async list () {
      let params = {
        ...this.searchForm,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      try {
        const res = await this.$http.post('/strategy/version-manage', params)
        if (res.code === '200') {
          this.tableData = res.data.rows
          this.total = res.data.total
        } else {
          this.$message.error(res.message)
        }
      } catch (err) {
        console.error(err)
      }
    },
    handleCurrentChange (currentPage) {
      this.pageIndex = currentPage
      this.list()
    },
    handleSizeChange (size) {
      this.pageSize = size
      this.list()
    },
    handleSelectionChange (val) {
      this.selectIds = []
      val.forEach(v => {
        this.selectIds.push(v.id)
      })
    },
    async handleCopyToEnv (params) {
      try {
        const res = await this.$http.post('/strategy/copy-to-env', params)
        console.log(res)
        if (res.code === '200') {
          this.$message.success('拷贝成功!')
        } else {
          this.$message.error(res.message)
        }
      } catch (err) {
        this.$message.warning('拷贝异常!')
        console.error(err)
      }
    },
    async copyToEnv (row, env) {
      this.$confirm('确认执行操作吗？', '提示', {type: 'warning'}).then(async () => {
        // 先查询指定环境是否存在该code的策略，如果存在询问是否覆盖
        try {
          let params = {
            code: row.code,
            strategyId: row.id,
            version: row.version,
            env: env
          }
          const res = await this.$http.post('/strategy/code-is-exist', params)
          console.log(res)
          if (res.code === '200') {
            if (res.data) {
              this.$confirm('环境存在该编码, 是否覆盖?', '提示', {
                confirmButtonText: '覆盖',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(async () => {
                this.handleCopyToEnv(params)
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消覆盖'
                })
              })
            } else {
              this.handleCopyToEnv(params)
            }
          } else {
            this.$message.error(res.message)
          }
        } catch (err) {
          this.$message.warning('查询code是否冲突失败!')
          console.error(err)
        }
      }).catch(action => {
      })
    },
    doRelease: debounce(300, function (row) {
      this.$confirm('确认发布吗？', '提示', {type: 'warning'}).then(async () => {
        try {
          this.strategy.id = row.id
          this.strategy.version = row.version
          const res = await this.$http.post('/strategy/release', this.strategy)
          if (res.code === '200') {
            this.$message.success('发布成功!')
            this.list()
            this.$emit('gotoNewVersionStrategy', row.code, Number(row.version) + 1)
          } else {
            this.$message.error(res.message)
          }
        } catch (err) {
          this.$message.error('发布异常!')
          console.error(err)
        }
      }).catch(action => {
      })
    }),
    async deleteDraft (row) {
      this.$confirm('确认删除草稿吗？', '提示', {type: 'warning'}).then(async () => {
        try {
          this.strategy.id = row.id
          this.strategy.version = row.version
          const res = await this.$http.post('/strategy/reset', this.strategy)
          if (res.code === '200') {
            this.$message.success('删除草稿成功!')
            this.list()
          } else {
            this.$message.error(res.message)
          }
        } catch (err) {
          this.$message.error('删除草稿异常!')
          console.error(err)
        }
      }).catch(action => {
      })
    },
    showHistory (row) {
      this.strategyHistory = row
      this.showHistoryFlag = true
    },
    showStrategyDetail (row) {
      const {href} = this.$router.resolve({path: `/strategy-edit/${row.code}/${row.version}`})
      window.open(href, '_blank')
    }
  },
  components: {
    'history': () => import('./history')
  }
}
</script>

<style scoped lang="stylus">

</style>



// WEBPACK FOOTER //
// src/views/versionManage/list.vue